import address from './address'

export default {
    ...address,
}
